import React, { FC, useCallback, useEffect, useState } from "react";
import { IncClickAwayProps } from "./types";

const IncClickAway: FC<IncClickAwayProps> = props => {
  const { children, onClickAway } = props;

  const [docEl, setDocEl] = useState<HTMLElement | null>(null);
  const ref = useCallback((element: HTMLElement | null) => setDocEl(element), []);

  useEffect(() => {
    if (!docEl) {
      return;
    }

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      // Skip if clicking select options (your existing hack)
      if (target?.classList.contains("inception-react-select__option")) {
        return;
      }

      // Check if click is inside the current popper element
      if (docEl.contains(target)) {
        return;
      }

      // Walk up the DOM tree to check for other poppers
      let currentElement: HTMLElement | null = target;
      let foundPopper: HTMLElement | null = null;

      while (currentElement && currentElement !== document.body) {
        if (currentElement.classList.contains("inc-popper")) {
          foundPopper = currentElement;
          break;
        }
        currentElement = currentElement.parentElement;
      }

      // If we found another popper, check if it's a child of the current popper
      if (foundPopper && foundPopper !== docEl) {
        // Check if the found popper is nested inside the current popper's content
        // (This handles the case where a child popper is rendered inside the current popper's DOM)
        if (docEl.contains(foundPopper)) {
          // This is a child popper nested inside the current popper
          // Don't close when clicking inside a child popper
          return;
        }
        // Found popper is a parent or sibling - allow closing
        // This enables closing inner poppers when clicking in parent popper area
      }

      // Click is outside the current popper (and not inside a child popper)
      // Trigger clickaway - this allows closing inner poppers when clicking in parent popper area
      onClickAway();
    };

    // Use mousedown - fires before potential stopPropagation on click
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [docEl, onClickAway]);

  return <>{children(ref)}</>;
};

export default IncClickAway;
